import { render, staticRenderFns } from "./EditBookingModal.vue?vue&type=template&id=64f729fb"
import script from "./EditBookingModal.vue?vue&type=script&lang=js"
export * from "./EditBookingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports